// extracted by mini-css-extract-plugin
export default {"cardCobroContainer":"cardPago_cardCobroContainer__9LEPt","btnBorrarCobro":"cardPago_btnBorrarCobro__zgZad"};